<template>
  <div>
    <template v-for="item in routerList">
      <el-submenu v-if="item.hasOwnProperty('children')&&item.children.length>0"
        :key="item.path"
        :index="item.path"
        >
        <template slot="title" style="padding-left:10px">
          <!-- <i class="el-icon-menu"></i> -->
          <span slot="title">{{ item.name}}</span>
        </template>
        <!--  如果有子级数据使用递归组件 -->
        <Menu :routerList="item.children"></Menu>
      </el-submenu>
      <el-menu-item v-else :index="item.path" :key="item.path">
        <!-- <i :class="item.icon"></i> -->
        <span>{{item.name}}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  props: ['routerList'],
  name: 'Menu', // 模板名称
  created () {
    // console.log(this.routerList, 'routerList')
  },
  methods: {

  }
}
</script>
<style>
.el-aside .el-submenu.is-active{border:none !important;}
.el-menu-item, .el-submenu__title{height:42px;line-height:42px;color:#555;margin-bottom:1px;}
.el-submenu__title:hover{background-color: transparent !important;color: #337eff;}
.el-submenu .el-menu-item{height:42px;line-height:42px;color:#555;margin-bottom:1px;min-width:0px;}
.el-aside .el-menu{padding-top:0px;}
.el-submenu .el-menu-item.is-active{background-color:#edeef0 !important;border-right:3px solid #337eff;color:#337eff;}
.el-submenu .el-menu-item:hover{background-color: transparent !important;color: #337eff;}
</style>
